import { IPost } from 'fitbeat.gym-core';
import React, { FunctionComponent, useState, useRef } from 'react';
import { ScrollView } from 'react-native';
import { BlogPostCard } from './BlogPostCard';
import { DashboardSection } from './DashboardSection';
import { HorizontalScroller } from './HorizontalScroller';
import { SeeAllCard } from './SeeAllCard';

interface IProps {
  heading: string;
  posts: IPost[];
  loading?: boolean;
  seeMoreLoading?: boolean;
  seeMorePressed?: () => void;
  seeMoreCardText: string;
  showSeeMoreButton: boolean;
}

export const BlogPostSlider: FunctionComponent<IProps> = ({
  heading,
  posts,
  loading = false,
  seeMorePressed,
  seeMoreCardText,
  seeMoreLoading,
  showSeeMoreButton,
}) => {
  const showOneWideCard = posts.length === 1;
  const scrollViewRef = useRef<ScrollView>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalItems = showSeeMoreButton ? posts.length + 1 : posts.length;

  return (
    <DashboardSection
      heading={heading}
      isLoading={loading}
    >
      <HorizontalScroller
        ref={scrollViewRef}
        currentIndex={currentIndex}
        onIndexChange={setCurrentIndex}
        totalItems={totalItems}
      >
        {posts.map((post, index) => (
          <BlogPostCard
            post={post}
            key={post.url}
            showOneWideCard={showOneWideCard}
            lastCard={!showSeeMoreButton && index === posts.length - 1}
          />
        ))}

        {showSeeMoreButton
          && (
          <SeeAllCard
            onPress={seeMorePressed}
            text={seeMoreCardText}
            loading={seeMoreLoading}
          />
          )}
      </HorizontalScroller>
    </DashboardSection>
  );
};
